import React from "react";

const ContactMap: React.FC = () => {
    return (
        <div>
            <div>
                <section className="map-section">
                    <div className="container">
                        <div className="map">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3402.8930792411884!2d20.098460100000004!3d32.0724367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13831dadbfbd0713%3A0xf25fa84ae33c3191!2sEbreaze%20Hotel!5e1!3m2!1sen!2sin!4v1734511429160!5m2!1sen!2sin"
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="ContactUs_Map"
                            ></iframe>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ContactMap;
